import axiosInstance from '@/api/axiosInstance';

export const previewPenaltySettlement = async () => {
  const response = await axiosInstance.post('/users/me/penalties/settlements/preview');
  return response.data;
};

export const startPenaltySettlement = async (payload) => {
  const response = await axiosInstance.post('/users/me/penalties/settlements', payload);
  return response.data;
};

export const getPenaltySettlementStatus = async (settlementId) => {
  const response = await axiosInstance.get(`/users/me/penalties/settlements/${settlementId}`);
  return response.data;
};
